export enum ChangeRequestStatus {
    Nieuw = 0,
    InDiscussie = 1,
    Goedgekeurd = 2,
    Afgekeurd = 3
}

export interface ChangeRequest {
    Id: number;
    Eurocode: string;
    Description: string;
    RequestedBy: string;
    RequestDate: Date | string;
    Status: ChangeRequestStatus;
    Attachments?: ChangeRequestAttachment[];
}

export interface ChangeRequestMessage {
    Id: number;
    ChangeRequestId: number;
    UserName: string;
    ContactId: number;
    Message: string;
    CreatedDate: Date | string;
    IsDeleted: boolean;
    CanDelete: boolean;
    Attachments: ChangeRequestAttachment[];
}

export interface ChangeRequestAttachment {
    Id: number;
    FileName: string;
    OriginalFileName: string;
    FileSize: number;
    ContentType: string;
    CreatedDate: Date | string;
}

export interface CreateChangeRequestDto {
    Eurocode: string;
    Description: string;
    AttachmentGuids?: string[];
    AttachmentFileNames?: string[];
}

export interface ChangeRequestParticipant {
    ContactId: number;
    FullName: string;
    CompanyName: string;
}

export interface UserGroup {
    UserGroupID: number;
    Usergroup: string;
}

